import React, {useEffect, useState} from 'react';
import {Flex} from '@chakra-ui/react';
import {CustomRadioGroup} from './FormInputs';
import {getServiceTypes} from '../../helpers/ServiceTypeDictionary';

const ServiceTypeList = ({control, defaultValue, filters}) => {
  const [services, setServices] = useState(1);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = () => {
    const serviceList = getServiceTypes(filters);
    setServices(serviceList);
  };

  return (
    <>
      {services.length > 0 ? (
        <Flex>
          <CustomRadioGroup name={'Service Type'} id={'ServiceType'} control={control} list={services} defaultValue={defaultValue ?? 1} />
        </Flex>
      ) : (
        <></>
      )}
    </>
  );
};

export default ServiceTypeList;
